import { Alert, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

import { createStructuredSelector } from 'reselect';
import * as Selectors from './selectors';
import * as Actions from './slice';

const stateSelector = createStructuredSelector({
  showStatusMessage: Selectors.makeSelectShowStatusMessage(),
  statusMessage: Selectors.makeSelectStatusMessage()
});

const NotificationLayout = () => {
  const dispatch = useDispatch();
  const { showStatusMessage, statusMessage } = useSelector(stateSelector);

  const handleCloseStatus = () => {
    dispatch({ type: Actions.closeStatusMessage.type });
  };

  return (
    showStatusMessage && (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={3000}
        open={showStatusMessage}
        onClose={handleCloseStatus}
        TransitionProps={{ onExited: handleCloseStatus }}
      >
        <Alert onClose={handleCloseStatus} severity={statusMessage.type} sx={{ width: '100%' }} variant="filled">
          {statusMessage.message}
        </Alert>
      </Snackbar>
    )
  );
};

export default NotificationLayout;
